module.exports = __webpack_public_path__ + "img/menu-svgrepo-com.3673289c.svg";